import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AppContext, DecryptSession } from "../../Context/Provider";
// Adjust the import path as necessary

const ProtectedRoute = ({ element }) => {
  const { secretKey } = useContext(AppContext);
  const location = useLocation();
  const plainData = DecryptSession(secretKey, "userId");
  console.log("plainData", plainData);
  const token = plainData?.data?.token;

  if (!token) {
    // If no token, redirect to the login page
    return <Navigate to="/login" replace />;
  }

  if (
    plainData?.data?.passwordChangeRequired &&
    location.pathname !== "/change-password"
  ) {
    return <Navigate to="/change-password" replace />;
  }

  // If token exists, render the requested component
  return element;
};

export default ProtectedRoute;
